/**
 * Application configuration
 */
export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  },
  polling: {
    // Global polling interval for the entire application
    global: Number(process.env.REACT_APP_GLOBAL_POLL_INTERVAL || 1000), // Default 1 second polling
  },
  pagination: {
    // Single default items per page for all tables (consistent pagination)
    defaultItemsPerPage: Number(process.env.REACT_APP_ITEMS_PER_PAGE || 10),
    // Default options for items per page dropdown
    itemsPerPageOptions: [10, 20, 50, 100]
  },
  ui: {
    defaultSortField: 'name' as const,
    defaultSortDirection: 'asc' as const,
  },
  auth: {
    adminPassword: process.env.REACT_APP_ADMIN_PASSWORD, // No fallback for security
    jwtSecret: process.env.REACT_APP_JWT_SECRET || 'development-jwt-secret',
    adminPath: process.env.REACT_APP_ADMIN_PATH || 'admin' // Path to admin settings page
  },
  batching: {
    // Default batch size and interval from useClickBatcher.ts
    size: Number(process.env.REACT_APP_BATCH_SIZE || 4),
    interval: Number(process.env.REACT_APP_BATCH_INTERVAL || 200),
  },
  stripe: {
    publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_your_key',
    secretKey: process.env.REACT_APP_STRIPE_SECRET_KEY || 'sk_test_your_key',
    webhookSecret: process.env.REACT_APP_STRIPE_WEBHOOK_SECRET,
  },
  app: {
    baseUrl: process.env.REACT_APP_URL || 'http://localhost:3000', // Used for Stripe redirect URLs
  }
};

export * from './emailConfig'; 